import React from 'react';
import DatePicker, {registerLocale} from 'react-datepicker';
import {DatePickerStructure, RawDatePickerWrapper} from './DatePickerStructure';
import styled from 'styled-components';
import {InputWrapper} from '../../input/Input';
import {useTranslation, withTranslation} from 'react-i18next';
import nl from 'date-fns/locale/nl';
import en from 'date-fns/locale/en-GB';
registerLocale('nl-NL', nl);
registerLocale('en-US', en);
// We import the en-GB locale to make the time format consitent with the hard coded settings, for which we choose the 24h clock

function RawGenericDatePicker({selected, nonePrefix, label, onChange, prefix, ...props}) {
    const {i18n, t} = useTranslation();

    return (
        <Wrapper nonePrefix={nonePrefix}>
            <DatePickerStructure {...props} label={label} htmlFor={prefix}>
                <DatePicker
                    locale={i18n.language}
                    autoComplete="off"
                    timeIntervals={15}
                    timeCaption={t('generalShared.time')}
                    selected={selected}
                    onChange={onChange}
                    {...props}
                    id={prefix}
                />
            </DatePickerStructure>
        </Wrapper>
    );
}

const Wrapper = styled(RawDatePickerWrapper)`
    position: relative;
    input {
        padding-left: 48px;
    }
    ${InputWrapper} {
        border-radius: var(--form-input-radius) !important;
        cursor: pointer;
    }

    .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,
    .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,
    .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::after,
    .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after {
        left: 20px;
    }
`;

export default withTranslation()(RawGenericDatePicker);
